import apiClient from '../../utils/apiClient';
import { API_ENDPOINTS } from '../../config/apiEndpoints';
import { FeatureFlag } from '../../types';

/**
 * Service for feature flag API interactions.
 */
export const featureFlagApi = {
  /**
   * Fetch all public feature flags.
   */
  getFeatureFlags: async (signal?: AbortSignal): Promise<FeatureFlag[]> => {
    return apiClient.get<FeatureFlag[]>(API_ENDPOINTS.PUBLIC.FEATURE_FLAGS, { signal });
  },

  /**
   * Update/toggle a specific feature flag.
   */
  updateFeatureFlag: async (key: string, isEnabled: boolean): Promise<void> => {
    const url = API_ENDPOINTS.SYSTEM.FEATURE_FLAG_UPDATE(key);
    return apiClient.put(url, { isEnabled });
  },
};
